import axios from 'axios'

const favouritesModule = {
    namespaced: true,
    state: {
      favourites: [],
      currentMaterial: 'mtCell',
    },
    getters: {
      getFavourites(state) {
        return state.favourites
      },
      getCount(state) {
        return state.favourites.length ? state.favourites.length : 0;
      },
      getFavouritesByMaterialType: (state) => (materialType) => {
        return state.favourites.filter(e => e.material_type == materialType);
      },
      getFavouritesCountByMaterialType: (state, getters) => (materialType) => {
        return getters.getFavouritesByMaterialType(materialType).length;
      },
      getFavouritesProductKeysByMaterialType: (state, getters) => (materialType) => {
        return getters.getFavouritesByMaterialType(materialType).map(e => e.donor_product_key);
      },
    },
    actions: {
      fetchFavourites({commit, dispatch}) {
        dispatch('clearFavourites');
        axios
          .get('/api/donor/favorites')
          .then((response) => {
            commit('setFavourites', response.data.data);
          })
          .catch((err) => {
            console.error(err);
          })
      },  
      addFavourite({commit, dispatch,  state}, favourite) {
        let itemFound = state.favourites.find(e => e.donor_product_key == favourite.donor_product_key && e.material_type == favourite.material_type);
        if(!itemFound) {
          commit('addFavourite', favourite);
          dispatch('sendFavourites');
        }
      },
      removeFavourite({commit, dispatch, state}, favourite) {
        let itemFound = state.favourites.find(e => e.donor_product_key == favourite.donor_product_key && e.material_type == favourite.material_type);
        if(itemFound) {
          commit('removeFavourite', itemFound);
          dispatch('sendFavourites');
        }
      },
      sendFavourites({state}) {
        let payload = {
          data: state.favourites
        }
        axios
          .post('/api/donor/favorites', payload)
          .then(() => {})
          .catch((err) => {
            console.error(err);
          })
      }, 
      clearFavourites({commit}) {
        commit('setFavourites', []);
      },
      setCurrentMaterial({commit}, currentMaterial) {
        commit('setCurrentMaterial', currentMaterial);
      },
    },
    mutations: {
      addFavourite(state, favourite) {
        state.favourites.push(favourite);
      },
      removeFavourite(state, itemFound) {
        state.favourites.splice(state.favourites.indexOf(itemFound), 1);
      },
      setFavourites(state, favourites) {
        state.favourites = favourites;
      },
      setCurrentMaterial(state, currentMaterial) {
        state.currentMaterial = currentMaterial;
      },
    }
  }

  export default favouritesModule;